<div>
    <div>
        <mat-form-field appearance="outline" class="w-p-100">
          <mat-select placeholder="Select a Language" [(ngModel)]="toLanguage">
            <mat-option *ngFor="let language of taxformsSupportiveLanguage" [value]="language.code" >
              {{language.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
    </div>
    <div>
        <mat-checkbox [(ngModel)]="isFileScanned">Treat as scanned</mat-checkbox>
      </div>
  <div>
    <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
      <mat-label>Storage * </mat-label>
      <input matInput placeholder="Input" style="display: none"
             particleAnalytics
             analyticsCategory= "choice-filter-modal-item-editor"
             analyticsAction= "entity-scope-input">
      <mat-radio-group [(ngModel)]="storageSettings">
        <mat-radio-button [value]="storageOptions.Stored" class="m-b-12">
          <div class="flex flex-col">
          <span>
            I want to store this document in Orbitax
          </span>
            <div class="hint flex flex-col">
              <div class="flex flex-row">
                Your document will be available to view, manage and share
                with your contacts via the Translation tool at any point.
              </div>
            </div>
          </div>
        </mat-radio-button>
        <mat-radio-button [value]="storageOptions.NonStored" class="m-b-12">
          <div class="flex flex-col">
          <span>
            I do not want to store this document in Orbitax
          </span>
            <div class="hint flex flex-col">
              <div class="flex flex-row">
                Your document will be available to download for 24 hours
                before being removed permanently from the system.
              </div>
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </mat-form-field>
  </div>
</div>
